var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-com flex flex-center opacity-5 width-full"},[_c('div',{staticClass:"flex flex-center"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png"),"alt":"logo"}})]),_c('div',{staticClass:"font-size-14 text-999 font-weight-bolder m-l-10"},[_c('div',[_vm._v("东方思锐软件提供IT技术支持")])])])
}]

export { render, staticRenderFns }